import { Component, inject } from '@angular/core';
import { CreateAufgabeFormService } from '../../../create-aufgabe-dialog/create-aufgabe.formservice';
import { RegisterBlattFacade } from '@schir-int-client/register-shared';
import { debounceTime, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AufgabenTyp } from '@schir-int-client/aufgabe-shared';

@Component({
	selector: 'schir-int-client-aufgabe-lfpr-mitteilung-editor',
	templateUrl: './aufgabe-lfpr-mitteilung-editor.component.html',
	styleUrls: ['./aufgabe-lfpr-mitteilung-editor.component.scss'],
	standalone: false,
})
export class AufgabeLfprMitteilungEditorComponent {
	private readonly formService = inject(CreateAufgabeFormService);
	private readonly registerBlattFacade = inject(RegisterBlattFacade);

	constructor() {
		// Nicht über Defaultwert lösbar, da bisher nur mit statischen Werten möglich.
		// Debounce und take 1, da Subscription zuerst auch alte Werte liefert, wir aber nicht ggf. schon getätigte Änderungen überschreiben wollen.
		this.registerBlattFacade.blattLuftfahrzeugrolleEntries
			.pipe(takeUntilDestroyed(), debounceTime(100), take(1))
			.subscribe(entries => {
				if (
					this.luftfahrtBundesAmtControls.nrLuftfahrzeugrolle.value === null ||
					this.luftfahrtBundesAmtControls.nrLuftfahrzeugrolle.value === ''
				) {
					if (entries?.length > 0) {
						this.luftfahrtBundesAmtControls.nrLuftfahrzeugrolle.setValue(entries[0].spaltenWert);
					} else {
						this.luftfahrtBundesAmtControls.nrLuftfahrzeugrolle.setValue('');
					}
				}
			});
	}

	get formGroup() {
		return this.formService.form.controls.LFPR_MITTEILUNG;
	}

	get bodyControls() {
		return this.formGroup.controls.body.controls;
	}

	get eigentuemerNeuControls() {
		return this.bodyControls.eigentuemerNeu.controls;
	}

	get eigentuemerAltControls() {
		return this.bodyControls.eigentuemerAlt.controls;
	}

	get notarControls() {
		return this.bodyControls.notar.controls;
	}

	get luftfahrtBundesAmtControls() {
		return this.bodyControls.luftfahrtBundesAmt.controls;
	}

	get glaeubigerNeuControls() {
		return this.bodyControls.glaeubigerNeu.controls;
	}

	get glaeubigerAltControls() {
		return this.bodyControls.glaeubigerAlt.controls;
	}

	get berechtigterControls() {
		return this.bodyControls.berechtigter.controls;
	}

	get rechtsanwaltControls() {
		return this.bodyControls.rechtsanwalt.controls;
	}

	protected readonly AufgabenTyp = AufgabenTyp;
}
